<template>
  <div class="rate-pricing">
    <span class="rate-pricing__before" v-if="pricing.before_price">
      € {{ pricing.before_price }}
    </span>
    <span class="rate-pricing__total" v-if="pricing.live_price">
      € {{ pricing.live_price }}
    </span>
    <p v-if="!rate_only" class="rate-pricing__label">include gestione e assistenza</p>
  </div>
</template>

<script>

export default {
  name: 'rate-pricing',

  components: {
  },

  props: {
    pricing: Object,
    rate_only: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .rate-pricing {
    text-align: center;

    @include media-breakpoint-up(lg){
      text-align: right;
    }

    &__before {
      font-size: $font-size-sm;
      font-weight: $vb-font-weight-semibold;
      text-decoration: line-through;
      color: $danger;
      line-height: normal;
    }

    &__total {
      font-size: 24px;
      font-weight: $vb-font-weight-semibold;
      color: $primary;
      line-height: normal;
      margin-left: $grid-gutter-width / 5;
    }

    &__label {
      color: $gray-600;
      font-size: $font-size-sm;
      margin-bottom: 0;
    }
  }

</style>